import PropTypes from 'prop-types'
import { Buscador } from '../reutilizables/buscador/Buscador.jsx'
import { GenericModal } from '../reutilizables/modal/GenericModal.jsx'
import { Paginacion } from '../reutilizables/paginacion/Paginacion.jsx'
import BordePrincipal from '../ui/BordePrincipal.jsx'
import styles from './ListaContenido.module.css'

export const ListaContenido = ({
  containerClassName,
  topRef,
  titulo,
  busqueda,
  setBusqueda,
  onBusqueda,
  onOrdenarAZ,
  onOrdenarPorVencimiento,
  onAgregarLista,
  labelAgregar,
  items,
  renderItem,
  onConfirmModal,
  onChangeModal,
  showGenericModal = true,
  modalGridProps,
  modalExtra,
  totalPaginas,
  paginaActual,
  onCambioPagina,
  itemsPorPagina,
  onCambioItemsPorPagina
}) => {
  return (
    <div className={containerClassName} ref={topRef}>
      <BordePrincipal titulo={titulo}>
        <>
          <div className="container">
            <div className="row">
              <div className={`${styles.ordenamientoContainer} mb-3`}>
                <div className={styles.buscadorWrapper}>
                  <Buscador
                    busqueda={busqueda}
                    setBusqueda={setBusqueda}
                    onChange={onBusqueda}
                    placeholder="Buscar lista..."
                  />
                </div>
                <button
                  type="button"
                  onClick={() => onOrdenarAZ('asc')}
                  className={`${styles.btn} ${styles.btnFiltro}`}
                >
                  A-Z
                </button>
                <button
                  type="button"
                  onClick={() => onOrdenarAZ('desc')}
                  className={`${styles.btn} ${styles.btnFiltro}`}
                >
                  Z-A
                </button>
                <button
                  type="button"
                  onClick={onOrdenarPorVencimiento}
                  className={`${styles.btn} ${styles.btnFiltro}`}
                >
                  Próximos vencimientos
                </button>
                <button
                  type="button"
                  onClick={onAgregarLista}
                  className={`${styles.btn} ${styles.btnAgregar}`}
                >
                  {labelAgregar}
                </button>
              </div>
              {items.length > 0 ? (
                items.map(renderItem)
              ) : (
                <div className="col-12">
                  <p className={styles.sinItems}>No hay items disponibles</p>
                </div>
              )}
              {showGenericModal && (
                <GenericModal
                  onConfirm={onConfirmModal}
                  onChange={onChangeModal}
                  ocultarGrid={!modalGridProps}
                  {...(modalGridProps || {})}
                />
              )}
            </div>
          </div>
          {modalExtra}
          {totalPaginas > 0 && (
            <Paginacion
              totalPaginas={totalPaginas}
              paginaActual={paginaActual}
              onCambioPagina={onCambioPagina}
              itemsPorPagina={itemsPorPagina}
              onCambioItemsPorPagina={onCambioItemsPorPagina}
            />
          )}
        </>
      </BordePrincipal>
    </div>
  )
}

ListaContenido.propTypes = {
  containerClassName: PropTypes.string.isRequired,
  topRef: PropTypes.object.isRequired,
  titulo: PropTypes.string.isRequired,
  busqueda: PropTypes.string.isRequired,
  setBusqueda: PropTypes.func.isRequired,
  onBusqueda: PropTypes.func.isRequired,
  onOrdenarAZ: PropTypes.func.isRequired,
  onOrdenarPorVencimiento: PropTypes.func.isRequired,
  onAgregarLista: PropTypes.func.isRequired,
  labelAgregar: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
  onConfirmModal: PropTypes.func,
  onChangeModal: PropTypes.func,
  showGenericModal: PropTypes.bool,
  modalGridProps: PropTypes.shape({
    onAddItem: PropTypes.func,
    onRemoveItem: PropTypes.func,
    onCopyField: PropTypes.func
  }),
  modalExtra: PropTypes.node,
  totalPaginas: PropTypes.number.isRequired,
  paginaActual: PropTypes.number.isRequired,
  onCambioPagina: PropTypes.func.isRequired,
  itemsPorPagina: PropTypes.number.isRequired,
  onCambioItemsPorPagina: PropTypes.func.isRequired
}

export default ListaContenido
